module.exports = __webpack_public_path__ + "10b5986213f0eca4669ba90f52d44ea7.png";